<div class="container d-flex h-100 w-100">
  <div class="row justify-content-center align-self-center w-100 h-100">
    <app-accentry-logo class="logo"></app-accentry-logo>
    <div class="tagLine">
      <h1>
        <b [@openClose]="isOpen5 ? 'open' : 'closed'">{{tagLine}} </b>
        <span [@openClose]="isOpen ? 'open' : 'closed'">bicycles,</span><br />
        <span [@openClose]="isOpen2 ? 'open' : 'closed'">parts</span>
        <b [@openClose]="isOpen3 ? 'open' : 'closed'"> and </b>
        <span [@openClose]="isOpen4 ? 'open' : 'closed'">accessories</span>
      </h1>
    </div>

    <div class="col-md-7 bg" [style.background-image]="bg"></div>

    @if (showContent) {
      <div class="ms-auto me-auto col-md-5 d-flex loginBox h-100">
        <div class="login-form justify-content-center align-self-center" style="z-index: 999;">
          <div class="main-div row">
            <div class="col-md-12">
              <div class="d-grid mt-4">
                <button
                  class="btn btn-block btn-lg btn-primary loginButton"
                  [disabled]="loading"
                  (click)="signInWithAuth0()"
                >
                  @if (!loading) {
                    <span>Sign in with Auth0</span>
                  }
                  @if (loading) {
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  }
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
